<template>
	<div class="tabs-layout">
		<md-tabs @md-changed="changeTab" md-active-tab="tab-site-first">
			<md-tab v-for="tab in tabs" :key="tab.id" :id="tab.id" :md-label="tab.tabTitle">
				<assignment-card :title="tab.title" :active="tab.active" :order="tab.order"></assignment-card>
			</md-tab>
		</md-tabs>
	</div>
</template>

<script>
import AssignmentCard from "@/pages/Clients/Technicians/components/AssignmentCard";
export default {
	name: "Technicians",
	components: {
		AssignmentCard
	},
	data() {
		return {
			tabs: [
				{
					id: 'tab-site-all', title: 'Liste de tous les sites', order: null,
					tabTitle: 'Tous les sites', active: false
				},
				{
					id: 'tab-site-first', title: 'Liste des sites sans technicien principal', order: 1,
					tabTitle: 'Sites sans technicien principal', active: true
				},
				{
					id: 'tab-site-second', title: 'Liste des sites sans deuxième technicien', order: 2,
					tabTitle: 'Sites sans deuxième technicien', active: false
				},
				{
					id: 'tab-site-third', title: 'Liste des sites sans troisième technicien', order: 3,
					tabTitle: 'Sites sans troisième technicien', active: false
				},
			],
		}
	},
	methods: {
		changeTab(id = 'tab-site-all') {
			this.tabs.map(tab => tab.active = false)
			let activeTab = this.tabs.find(tab => tab.id === id)
			activeTab.active = true
		},
	},
}
</script>

<style scoped lang="scss">

</style>
